module.exports = __webpack_public_path__ + "88dde121165d9ac4da9351e497c23ffe.jpg";